import { Button, ButtonProps, Popover, Stack } from '@shopify/polaris';
import { FunctionComponent, useRef } from 'react';
import DropDown, { DropdownProps, DropdownRef } from '../dropdown';

export type FilterDropDownProps = DropdownProps & {
  applyProps?: ButtonProps;
  cancelProps?: ButtonProps;
  onApply: (value?: any) => void;
  onCancel?: (value?: any) => void;
};

const FilterDropDown: FunctionComponent<FilterDropDownProps> = ({
  applyProps,
  cancelProps,
  children,
  onApply,
  onCancel,
  ...props
}) => {
  const dropDownRef = useRef<DropdownRef>();

  const onRef = (dropDown: DropdownRef) => {
    dropDownRef.current = dropDown;
  };

  const onClickApply = () => {
    dropDownRef.current?.close();
    onApply();
  };

  const onClickCancel = () => {
    dropDownRef.current?.close();
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <DropDown {...props} onRef={onRef}>
      <Popover.Pane>
        <Popover.Section>
          <Stack vertical>{children}</Stack>
        </Popover.Section>
      </Popover.Pane>
      <Popover.Pane fixed>
        <Popover.Section>
          <Stack distribution="equalSpacing">
            <Button {...cancelProps} onClick={onClickCancel}>
              Clear
            </Button>
            <Button {...applyProps} onClick={onClickApply} primary>
              Apply
            </Button>
          </Stack>
        </Popover.Section>
      </Popover.Pane>
    </DropDown>
  );
};

export default FilterDropDown;
